import React, { useState } from "react";
import { FRAMEWORKS } from "../lib/siteData";
import { ArrowUpRight } from "lucide-react";

export default function Frameworks() {
  const [active, setActive] = useState(0);

  return (
    <section
      id="frameworks"
      data-testid="frameworks-section"
      className="py-20 sm:py-28 bg-ivorySoft border-y border-ink-10"
      style={{ borderColor: "rgba(11,31,56,0.12)" }}
    >
      <div className="container-prose">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-12">
          <div className="lg:col-span-7">
            <p className="overline">03 — Original Work</p>
            <h2 className="h2-display mt-4 text-4xl sm:text-6xl text-ink">
              Frameworks built in <span className="italic text-forest">classrooms</span>,
              tested at <span className="italic text-forest">scale</span>.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="body-prose text-base sm:text-lg text-ink/75 max-w-md">
              Each framework below was created to solve a real classroom problem and refined
              across thousands of teachers. They translate global research into Indian practice.
            </p>
          </div>
        </div>

        <div className="border-t border-ink-10" style={{ borderColor: "rgba(11,31,56,0.18)" }}>
          {FRAMEWORKS.map((f, i) => (
            <button
              key={f.code}
              data-testid={`framework-row-${f.code}`}
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => setActive(i)}
              className={`group w-full text-left border-b transition-all duration-500 ease-out ${
                active === i ? "bg-ink text-ivory" : "bg-transparent text-ink hover:bg-ivory"
              }`}
              style={{ borderColor: "rgba(11,31,56,0.18)" }}
            >
              <div className="container-prose !px-0 grid grid-cols-12 items-start gap-6 py-7 sm:py-9">
                <div className="col-span-2 sm:col-span-1">
                  <span
                    className="text-sm tracking-widest"
                    style={{ fontFamily: "Outfit, sans-serif" }}
                  >
                    {f.code}
                  </span>
                </div>
                <div className="col-span-10 sm:col-span-5">
                  <h3
                    className="h2-display text-2xl sm:text-4xl"
                    style={{ fontFamily: '"Cormorant Garamond", serif' }}
                  >
                    {f.name}
                  </h3>
                  <p className={`mt-2 text-[12px] uppercase tracking-[0.22em] ${active === i ? "text-ivory/70" : "text-forest"}`}>
                    {f.tag}
                  </p>
                </div>
                <div className="col-span-12 sm:col-span-5">
                  <p
                    className={`body-prose text-base leading-relaxed transition-all duration-500 ${
                      active === i ? "text-ivory/85 max-h-[300px] opacity-100" : "text-ink/70 max-h-[80px] sm:max-h-[60px] opacity-80 line-clamp-2"
                    }`}
                  >
                    {f.description}
                  </p>
                </div>
                <div className="col-span-12 sm:col-span-1 flex justify-end">
                  <ArrowUpRight
                    size={20}
                    className={`transition-transform ${
                      active === i ? "translate-x-1 -translate-y-1 text-ivory" : "text-ink/40"
                    }`}
                  />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
